import React from "react";
import { useNavigate } from "react-router-dom";

function About() {
  const navigate = useNavigate();

  return (
    <div className="max-w-md mx-auto">
      <div className="px-5 pt-6 pb-2 flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center text-gray-600"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <h1 className="text-2xl font-bold text-gray-900">About</h1>
      </div>

      <div className="mx-5 mt-6 flex flex-col items-center text-center">
        <img
          src="logo.png"
          alt="WaitLessQ"
          className="w-20 h-20 rounded-2xl mb-4"
        />
        <h2 className="text-xl font-bold text-gray-900">WaitLessQ</h2>
        <p className="text-sm text-gray-400 mt-1">Version 1.0.0</p>

        <div className="w-12 h-px bg-gray-200 my-5" />

        <div className="bg-white rounded-2xl shadow-card p-5 w-full">
          <p className="text-sm text-gray-700 leading-relaxed">
            WaitLessQ helps you manage your restaurant queue effortlessly. No
            more paper lists or shouting names — just a simple, smart waitlist.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-card p-5 w-full mt-4">
          <h3 className="text-sm font-semibold text-gray-900 mb-3">
            Developed by
          </h3>
          <p className="text-sm text-gray-700 font-medium">
            Pazhanam Technologies Pvt Ltd
          </p>
          <p className="text-sm text-gray-500 mt-1">India</p>
          <a
            href="mailto:info@pazhanam.com"
            className="inline-block mt-3 text-sm text-primary font-medium"
          >
            info@pazhanam.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default About;
